import { get, mapKeys, mapValues } from 'lodash'

const KEY_MAPPING = {
  c: 'has_checks',
  d: 'has_data',
  n: 'has_notes',
  tp: 'has_text_properties',
  t: 'has_todos',
  oi: 'object_id',
  ot: 'object_type',
  o: 'outdated',
  r: 'reconciled',
  r1: 'reconciliation_not_necessary',
  r2: 'reconciliation_not_necessary_and_no_required_inputs',
  m: 'required_keys_missing',
  s: 'starred',
}

const VALUE_MAPPING = {
  1: true,
  0: false,
  r: 'reconciliation_text',
  a: 'account',
  rt: 'reconciliation_text',
}

const decompressWorkflowProgresses = function (progresses) {
  return progresses.map((progress) => {
    const mappedKeys = mapKeys(progress, (_value, key) => {
      return get(KEY_MAPPING, key, key)
    })

    const mappedValues = mapValues(mappedKeys, (value, _key) => {
      return get(VALUE_MAPPING, value, value)
    })

    return mappedValues
  })
}

export default decompressWorkflowProgresses
